import { render, staticRenderFns } from "./VideoWithDnD.vue?vue&type=template&id=ba54a03a&scoped=true&"
import script from "./VideoWithDnD.vue?vue&type=script&lang=ts&"
export * from "./VideoWithDnD.vue?vue&type=script&lang=ts&"
import style0 from "./VideoWithDnD.vue?vue&type=style&index=0&id=ba54a03a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba54a03a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VRow,VSpacer,VTooltip})
